import axios from 'axios';
import {
  CONSOLIDATED_MIS_REQUEST,
  CONSOLIDATED_MIS_SUCCESS,
  CONSOLIDATED_MIS_FAIL,
} from '../constants/consolidatedMisConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const fetchConsolidatedMis = (month, year) => async (dispatch, getState) => {
  try {
    dispatch({ type: CONSOLIDATED_MIS_REQUEST });

    const { userLogin: { userInfo } } = getState();
    const config = { headers: { Authorization: `Bearer ${userInfo.token}` } };

    const { data } = await axios.get(
      `${API_URL}/consolidated-mis?month=${month}&year=${year}`,
      config,
    );

    dispatch({ type: CONSOLIDATED_MIS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: CONSOLIDATED_MIS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
